const { each } = require("jquery");

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
import moment from 'moment';
require('moment-precise-range-plugin');

/* $(document).on('turbolinks:load', function () {
    resizeDiv();
});

window.onresize = function(event) {
resizeDiv();
}

function resizeDiv() {
    const vph = $(window).height();
    const nvh = $('.menu-w').height();
    const snvh = $('.sub-menu-w').height(); // sub menu height
    const nav = nvh + snvh;
    const fvh = $('.footer-w').height();
    const sm = 60; //sidebar margin
    const nmb = 42; //navbar margin bottom
    const height = vph - nvh - nmb;
    if (height > 100){
        $('.fullheight').css({'height': height + 'px'});
    }
    //$('.hs-sidebar').css({'max-height': vph - nav - sm + 'px'})
    $('.fullscroll').css({'height': vph + 'px'});
    $('.fullpage').css({'min-height': vph + 'px'});
    $('.content-home').css({'min-height': vph - nvh - fvh + 'px'});
    console.log(height);
    console.log("window height:" + vph);
    console.log("nav height:" + nav);
    console.log("menu:" + snvh);
} */

$(document).on('turbolinks:load', function () {
    $('[data-toggle="offcanvas"]').on('click', function () {
        $('.offcanvas-collapse').toggleClass('open')
    })

    $('.navbar-nav>li>.nav-link').on('click', function(){
        $('.offcanvas-collapse').toggleClass('open')
    })
});

$(document).on('click', '[data-toggle="lightbox"]', function (event) {
    event.preventDefault();
    $(this).ekkoLightbox({
        alwaysShowClose: true
    });
});

$(document).on('click', '[data-behaviour="reload-on-click"]', function (event) {
    Turbolinks.visit(location.toString());
});

$(document).on('click', 'a.remove_fields', function (e) {
    let link = $(this);
    if (link.hasClass('remove_fields')) {
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Find the parent wrapper for the set of nested fields.
        let fieldParent = link.closest('.nested-fields')
        // If there is a parent wrapper, find the hidden delete field.
        let deleteField = fieldParent
            ? $(fieldParent).find('input[type="hidden"]')
            : null
        // If there is a delete field, update the value to `1` and hide the corresponding nested fields.
        if (deleteField) {
            $(deleteField).val(1);
            $(fieldParent).hide();
        }
    }
});

$(document).on('click', '[data-behaviour="appstorelink"]', function (event) {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // some code..

        var anchor = this;
        event.preventDefault();
        var now = new Date().valueOf();
        setTimeout(function () {
            if (new Date().valueOf() - now > 100) return;
            window.location = $(anchor).attr('href');
        }, 50);
        window.location = $(this).data('applink');
    }
});

window.turbolinksReload = function () {
    Turbolinks.enableTransitionCache(true);
    Turbolinks.visit(location.toString());
    Turbolinks.enableTransitionCache(false);
}

$(document).on('turbolinks:load', function () {
    $('.select2').each(function (idx) {
        $(this).width();
    });
});


window.FontAwesomeConfig = { autoReplaceSvg: 'nest' }

$(document).on('turbolinks:load', function () {
    $('.sharing-list').each(function () {
        const $select = $(this);
        const $modal = $select.closest('.modal');
        const $container = $select.closest('.modal-body');
        const $controls = $container.find('.js-sharing-membership-controls');
        const $selectionCount = $controls.find('.js-sharing-selection-count');

        if (!$select.hasClass('select2-hidden-accessible')) {
            $select.select2({
                width: 'resolve',
                placeholder: $select.data('placeholder') || 'Select users to share with',
                dropdownParent: $modal.length ? $modal : $(document.body)
            });
        }

        if ($controls.length === 0) {
            return;
        }

        const updateSelectionCount = function () {
            const selectedCount = ($select.val() || []).length;
            $selectionCount.text(selectedCount);
        };

        updateSelectionCount();
        $select.off('change.membershipSharing').on('change.membershipSharing', updateSelectionCount);

        $controls.find('.js-select-shareable-memberships')
            .off('click.membershipSharing')
            .on('click.membershipSharing', function () {
                const selectableValues = $select.find('option:not(:disabled)').map(function () {
                    return $(this).val();
                }).get();
                $select.val(selectableValues).trigger('change');
            });

        $controls.find('.js-clear-shareable-memberships')
            .off('click.membershipSharing')
            .on('click.membershipSharing', function () {
                $select.val([]).trigger('change');
            });
    });
});


$(document).on('turbolinks:load', function () {
    $('input.timepicker').timepicker({
        minuteStep: 15,
        defaultTime: '',
        // secondStep: 5,
        showInputs: false,
        // template: 'modal',
        // modalBackdrop: true,
        showSeconds: false,
        showMeridian: false
    });
});

$(document).on('turbolinks:load', function () {
    $('.modal').appendTo("body");

    // Convert Bootstrap 5 data attributes to Bootstrap 4
    $('[data-bs-toggle="collapse"]').each(function() {
        $(this).attr('data-toggle', 'collapse').removeAttr('data-bs-toggle');
    });
    $('[data-bs-target]').each(function() {
        var target = $(this).attr('data-bs-target');
        $(this).attr('data-target', target).removeAttr('data-bs-target');
    });
    $('[data-bs-parent]').each(function() {
        var parent = $(this).attr('data-bs-parent');
        $(this).attr('data-parent', parent).removeAttr('data-bs-parent');
    });
    
    // Initialize collapse for Bootstrap 4
    $('[data-toggle="collapse"]').on('click', function(e) {
        e.preventDefault();
        var target = $(this).data('target');
        $(target).collapse('toggle');
    });

    // Scoped compatibility dropdowns for HR membership header actions/export.
    const membershipHeaderDropdownSelector = '#actionsDropdown, #exportDropdown';
    const closeMembershipHeaderDropdowns = function () {
        $(membershipHeaderDropdownSelector).each(function () {
            const dropdown = $(this).closest('.dropdown');
            dropdown.removeClass('show');
            dropdown.find('.dropdown-menu').first().removeClass('show');
            $(this).attr('aria-expanded', 'false');
        });
    };

    if ($(membershipHeaderDropdownSelector).length > 0) {
        $(document).off('click.hrMembershipDropdown');

        $(membershipHeaderDropdownSelector).off('click.hrMembershipDropdown').on('click.hrMembershipDropdown', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const dropdown = $(this).closest('.dropdown');
            const menu = dropdown.find('.dropdown-menu').first();
            const shouldOpen = !dropdown.hasClass('show');

            closeMembershipHeaderDropdowns();
            if (shouldOpen) {
                dropdown.addClass('show');
                menu.addClass('show');
                $(this).attr('aria-expanded', 'true');
            }
        });

        $(document).on('click.hrMembershipDropdown', function (e) {
            const inMembershipHeaderDropdown = $(e.target).closest('.dropdown').find(membershipHeaderDropdownSelector).length > 0;
            if (!inMembershipHeaderDropdown) {
                closeMembershipHeaderDropdowns();
            }
        });
    }
});

$(document).on('turbolinks:load', function () {

    $(".search-box").on("keyup", function () {
        var search_term = String.prototype.trim.call(this.value.toLowerCase());
        var search_terms = search_term.split(' ');
        $('.searchable-report').each(function () {
            var category_element = $(this);
            var searchable_content = category_element.data('searchablecontent');
            var match = true;
            for (var i = 0; i < search_terms.length; i++) {
                if (searchable_content.indexOf(search_terms[i]) == -1) {
                    match = false;
                    break;
                }
            }
            if (match) {
                category_element.show();
                return category_element.css('display', 'block');
            } else {
                category_element.hide();
                return category_element.css('display', 'none');
            }
        });
    });

    $(".search-premium-categories").on("keyup", function () {
        var search_term = $.trim(this.value.toLowerCase());
        $(this).closest('.search-wrapper').find('.premium-category').each(function () {
            var category_element = $(this);
            if (category_element.data('categoryname').indexOf(search_term) != -1) {
                category_element.show();
                return category_element.css('visibility', 'visible');
            } else {
                category_element.hide();
                return category_element.css('visibility', 'hidden');
            }
        });
    });

    $('.select2').each(function (idx) {
        $(this).width();
    });
    $('#addMember .select2').select2({
        dropdownParent: $("#addMember"),
    });
    $('.selector').select2();

    if ($('.dt-detailed-report').length) {

        $('.dt-detailed-report thead tr').clone(true).appendTo('.dt-detailed-report thead');
        $('.dt-detailed-report thead tr:eq(1) th').each(function (i) {
            var title = $(this).text();
            if (i == 5) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="all">All</option><option value="pass">Pass</option><option value="warning">Warning</option><option value="failure">Failure</option></select>');
            } else if (i == 3) {
                $(this).html('<select style="width: auto" class="form-control form-control-sm"><option value="all">All</option><option value="today">Today</option><option value="since_yesterday">Since yesterday</option><option value="in_last_week">In last week</option><option value="in_last_month">In last month</option><option value="in_last_3_months">In last 3 months</option><option value="in_last_6_months">In last 6 months</option></select>');
            } else if (i == 4 || i == 6 || i == 7 || i == 8) {
                $(this).html('');
            } else {
                $(this).html('<input type="text" style="width: auto" class="form-control form-control-sm" placeholder="Filter by ' + title + '" />');
            }

            $('input', this).on('keyup change', function () {
                if (detailed_report_table.column(i).search() !== this.value) {
                    detailed_report_table
                        .column(i)
                        .search(this.value, true, false)
                        .draw();
                }
            });
            $('select', this).on('change', function () {
                if (detailed_report_table.column(i).search() !== this.value) {
                    detailed_report_table
                        .column(i)
                        .search(this.value, true, false)
                        .draw();
                }
            });
        });


        var detailed_report_table = $('.dt-detailed-report').DataTable({
            orderCellsTop: true,
            fixedHeader: true,
            bDestroy: true,
            order: [[3, 'desc']],
            columnDefs: [
                {
                    targets: [8],
                    visible: false,
                    searchable: false
                }
            ],
            stateSave: false,
            dom: 'Bfrtip',
            search: {
                "regex": true,
            },
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="picons-thin-icon-thin-0094_file_table"></i><span class="ml-2">Export CSV</span>',
                    className: 'btn btn-primary',
                    titleAttr: 'Export CSV',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
                    }
                },
                {
                    extend: 'pdf',
                    text: '<i class="picons-thin-icon-thin-0077_document_file_pdf_adobe_acrobat"></i><span class="ml-2">Export PDF</span>',
                    className: 'btn btn-primary',
                    titleAttr: 'Export PDF',
                    title: "Reports " + (new Date()).toDateString(),
                    footer: true,
                    orientation: 'landscape',
                    exportOptions: {
                        columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
                    },
                    customize: function (doc) {
                        // Splice the image in after the header, but before the table
                        // doc.defaultStyle.font = 'Arial';
                        // doc['header'] = (function (page, pages) {
                        //     return {
                        //         columns: [
                        //             { text: 'Safety Revolution', style: 'header' },
                        //             ''
                        //         ],
                        //         margin: [42, 20],
                        //     }

                        // });
                        doc['footer'] = (function (page, pages) {
                            return {
                                columns: [
                                    {
                                        alignment: 'left',
                                        text: [(new Date()).toDateString()]
                                    },
                                    {
                                        alignment: 'right',
                                        text: ['Page ', { text: page.toString() }, ' of ', { text: pages.toString() }]
                                    }
                                ],
                                margin: [42, 20],
                            }
                        });
                        doc.content[1].table.widths = ['20%', '10%', '10%', '10%',
                            '10%', '6%', '6%', '6%', '22%'];
                        var rowCount = doc.content[1].table.body.length;
                        for (var i = 1; i < rowCount; i++) {
                            doc.content[1].table.body[i][3].alignment = 'center';
                            doc.content[1].table.body[i][4].alignment = 'center';
                            doc.content[1].table.body[i][5].alignment = 'center';
                            doc.content[1].table.body[i][6].alignment = 'center';
                            doc.content[1].table.body[i][7].alignment = 'center';
                            doc.content[1].table.body[i][8].alignment = 'center';
                        }
                        doc.content.splice(0, 0, {
                            margin: [0, 0, 0, 0],
                            alignment: 'right',
                            width: 80,
                            image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAAA1CAYAAACTBQODAAANGUlEQVR42u1ce3QU1RlfVMBHRUVQsWp9YPFYqrU+ahVtlEJmZpMASuxD6wusRUV8Fd8atSocECjyyOzsZoEAwZDsO5ts9hUSMNYGC1XwdXpA0SLtsf2n2taq299v3dFhMjvZTWjPIvc75ztzd+a73/3uvb/5vu/eO4ljf6XEkvHHJjTltwm3UptwSVmOu+TlcZe0tF2VlpBTbmVpwl0+O5NxDCpUb8pVfk3nSqfrS52avCyuyirLeVmTVbS7ANdfpj2V49LeyUc7BJUWhdXKw1OapKQ8zqp2l5RlAGYeQPRZ54qKzAavM9OFa8Ilf9LmLh9dqN6Y2zm2s06ZRH2xWrmy3aW4ky7lRv6245gmT024lAeTbqWzw+N8H2Bdl3RJU7w1ZYc6BJUmxVR5MkDTFHcpn+GaAedAo8zqj750uuwQAPDOourUlB2SdDvv00EL4PQk3XKlQ1DpEbzJtfAIvwJQ3sZEZQHTgUlDuOjMZDKDigZgrXI5vUR/bGlX5ScJmo46ZybtUT4HiJ/KhkZBpUPIN65PebKhaTE9CwGT0LL8z7RaeVbR+lT5rqgmn9QfW6KL5WEA8A4ClzZk7VGlBxyCSgswCYSlNq38spQHHkYPSysrMrg/uxhdyHuGMycZkMfTpCU6cJHbkD9K1MlnOwSVDmDg+q/pUc8f3I6wlM6BhmEBv7sbG6sPLniy3YrEnGhgOZV0A8OSDtyNK1HWlGcdgkoHMO210s9yE/4cPYselvD7362adE7h3kF+KO1VThiYh1Em6KAFMwnmNe0QVBqUwBudcEs3sBxzOS9Jug2rpSx4lEcKCkdq+Sgkyo8MGMDeijI9+SanPU5et2Zqag5yCCoNwGBP5EaWtzVWD+HkcJL0sIQktIfL3r5XOFL1vlgKt2uSkq7Ltq/bwGu3Q1DpAYYUV5UaY1hKavJ/kmr59/vSwyVwtE4euQ/sudWYw+RscTkElSZg2mrLz00id0loxgmTnrJNVLWJp8U16fF9YQ93iTsNy3vux0B3mUNQaQKGqyIkwi/mQkEmnQ1LyhbcH5JPB48BkDgrA85f1B8fhTbf0XOYjasqMwh1q8TmXQkDhgSA3PNlWALD43waXyZfbFWfySjqPxdZ5jxm4N5Fvr/TC4BqCsBSQQ/Tll4oDiVLb5WkSdP2mrjaCWcCLB8ZwhKBM8eqPjfVmPcMHCzSFHiWf22CV8Hh6MdIoOf14LDUIai0iOEkoSq3mm4PQt4Sxx6IcWm7Pe3tfYqMib0DZ0ATjfcYQrjri6OFETontKrjE9r44/kZA48AuuCR0jhCSKjOK7Df400hVwHvTnlkNb5cPs8haP8BDAkAucW4WuH+DI8PjDLcHeZW/kZP1ZHG+41zmItIWwGAPai7J1Wn7GnX5A3wIs/Aa60Ar8fzAK4+8Dp4r7kpt9NJYDkE7Z+A4QEicpm/JzXlq9WSKi/cO9eRLoxrvcORf2HZ0UicdyNxJtCyyStBoifV9FTwMkNFMvu1AYwOCNnX6a3IhSWFgHkrbMgrYjhojGsVZVaAQZ339NVOzlM1OQR93QEj/VTPY8jcE8HyeXzWUyyoPox7JkxMBWAEYPRPOkdgB/cDhBXjJt5SPuNmGjzQYywLwBxAhBzkppia/5NKTPRKPfnl9zJYEe3gmROPAuKqNE4A5gAETLvN97txrF6Mh4FfeJvya/hXAdGoPFQARgBmL+KSGZO9E5OvA4a8A57mXj4XgBGAsfp0YYnhBBusfMo/LRGAEYDJd8bzI+7EfvXpprSJZ0gCMAIwlsSNNh4NcC+GnkYPRwIwBypg7AGg78k8k92xdSkfpzzSGAGYA5QwkTfzs4I+T5NrlQty38h0cEtfAOYApUStdB1C0j2F/DkrwxL4vr5kFy8ePRQg3LU3YKQXHIL2Lwpiicy/EMCyeHq7+gVjQleDgyzrnATHlk88rvcH2srtFqsjgK5c6vDIt+j1E6p0J3Rmv23pAli6V1dlcBj5qrENyvPTToeg0qWXVsvDMJEzsTS+l3kLmX/ayqSXZZ0TvD4/4URzfX6mWWOxOsIxwVUbVji/qg+PlQC4kPfcpjPbNbaRlfdWnOkQJEiQIEGCBAkSJEiQIEGCBAkSJMhAPp+vwu/3z2xsbDzYIUiQHQWDwXMCPt/rAEzZ16ZTsVjsiHQ6fXQxdSiPwTjSIciWQn6/DA/zw34rCAQCT7S2tESAuO/lQeQFiXg8DLkpdnrg3kZGQqFm6LnI1uBQ6OKg3z8/j44T8LwuFAx2o92XwqFQAu0q+f5lamzVqiPCweCDkOuC/GbU7QG3os5UOzDiDWuAzN15xmNBmH0okGgb+rMoEg5HgoFABLYHwuHw3Obm5tPz6H+6JRLJyqJeGLZrsP1yy7Hy+SaFAoGHTeHkWNSrh56Trerg2exAc/N04z00dzrmJQTbouh7EDIBtM9xCsLOk0xzMASyKuyKQo7yrWBApKUVbU9w4EcKgMigssvyeN/nW7GhoyMDw20/G4DyWdGWlo+hZ7WdHIy5OuD3/8F8X1XVwbifwIR70YlvEYAoz4TeZVaxNhqNjkRbL2JyohjwK1BnFOuhfB3u0eU+bwW0NWvWHIM+/QVA+8RqoqBzKwAzuQjAHAS7t8PW+zHBVzI/wIuzFPfeht2nWPT/5RBAQ1m0VU5AYCI/gO3OXmPq8/2ak2ZuD/U2Qs+DFi/cUWh3F8fD1OZFuL+HLz1YIYfB0C/xBTLpOAyyO6DjHsrpDNA5Ca4sYCAQB2+D0ImmwTsZ/BpkunF9yPjMopEeDNZVjI8tPt+3bQAzGbIv9RqcxsbR7CyeFxKKBqGd9QEI8wDRwp5v5nRNMz9Dx4/Bs1fxbBH7HI/HjzJPKAazshjAYFK3YDD3Ah90p3H/DpZN9zcRkKY2n4Jss1kWfbyb3sDC61+LZ1sRhg8xzdfPof8VvmAWgNlmHCu7uYSe1zGX51oKQFEnGp8HpWtxfcBkwMN47sUzN549ZhPWfoKOdeQ8koduvVjA0EOg3u7A+vWX8HcfYe070PFX6DrVJlZPCwLsPfBcZsDA1rdQ9wzoILn3BWBg+2Umj9sFXTOsAMNQYxq/7PgXChh6EozzTozZpSbdMdS5j2UzYDgWLBcKGFy/mxcwNBiIGkd3zBiWc/lDORBsDFcPAZMvhvNtwgT9Qs95IP8nTkwxgCERsMgFdqHuHIDiQhvQTYOO3/cBqtMg8wFBZeFh3o4CMAQp2tzNCRwIYBhi0d5DdN0MuWHkYfRi1G9hexdC1jyGB9SZhNA4H2FpJ/MmO8BYPKuFDs2g9wyA4h2GDas8FPb8mWkDeAYZNtyG+1V5osUbeDZXl0V5BsLXzQj1h2cBA14MWSZvmxmDc6ivhAHdOeNWEzD5kljU/6PRPTLEQf72YgFDglHjmAiiQ9tawuGOYFPTORYejQOZ7GOv4Ti08z5kz7YCDNo5y+DGGfeP7w9g6OYxTq9A3yZ6LOhpiASDj1qBhURPjJfiRcg2od7nyF/qdVuKAAzt/gFzDT2EQ+5RcHOeMT8fHulDtOdiTkjG2C6HrbMsVpuHQv5NzGuTPycLUPM6H05kWBYw+PG8nrhCcThnbFB3qZBZkw8wkKnHAKf4ljKHQYY+hR5JB1ExgDG7XQzkc4y9KH/DNFhTAuhUDfTb7Decx7eKybMNYHR968Drc3393UByGDPZhSR6doKMZTvA2LT7Mt78a/mbNqDPTpb/5yFJBwwHlxl/U1PTZBqA38PtAINBP8WPSYFH8LNjBBmZSEedD+FmJxYLGPMSGLLvmr1EeO3aEfQeQa4s8hDfDMiEWLYBjNEbvQvbr6cH6A9g0K/xhQIGk1zNMr0Dfu9kElssYHL178LYhLivwsUJJzsfYDivfF4oYPACXGgLGIORC9paW/+GSs/ytx1gIPMbcDBPZ58GtxYKGO4vYBJvoos3ul3oeI/hwkLPDIImAndrfoYJn86lc8TnG1sIYEgAXxVzHryJu5iL/D8Ao4dE9pH9LxYwXNVyVYrw0QW5J83PzaukYjxMkzEVMC//EKMWGSZuLGIsJ2mMYS+mHgY9YlI8nKsNyF9ppbcFeyL+5uZd3BA0TVgVB62XHQ0NJyOeb0Tno5jwO2HT4/Bcr/HMwyaxvQ22bmGSyX2DEJb+KIdwbxM6bVxtmVdJb7S2to6x8ErzU8nkR2hzYjGAwfhsth4H6xcU/ZtqzIFgKzfxVJZNEz0LY9Jspw9j7I6Gw/9gEm8XnpnDQN8L4DU6I09cy6MCM2Agux0vTptRFmO7Jrv65cASJMYOAF3ncfVjbNBn2ltpa2sbzoFN2+QRLdgYw8Scat7NDWNFlqdjR2K+b4Sxb6IcBl9qlrEKi+j4XTnX3oXfU+2OCHp6egZzY8tKJo1ciRtUDFHF7PSynxiHEYXIs0/BhoYTzftGGEvZPJYR7BaHEBr66n9fYOVeE8a1Asl4ddDA6Gt1fX39KPMLwPHBzu7VZll63v8CZMLNiU/t0nwAAAAASUVORK5CYII='
                        });
                    },
                }
            ]
        });
        document.addEventListener("turbolinks:before-cache", function () {
            if (detailed_report_table !== null) {
                detailed_report_table.destroy();
                detailed_report_table = null;
            }
        });
    } else {
        $('.dt-detailed-report').hide();
    }

    var dt1 = $('.dt').DataTable({
        stateSave: true,
        bDestroy: true,
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt1 !== null) {
            dt1.destroy();
            dt1 = null;
        }
    });

    function format(d) {
        // `d` is the original data object for the row
        return (
            '<table cellpadding="0" cellspacing="0" border="0" class="table table-sm table-striped table-child mb-0" width="100%">' +
            '<tr>' +
            '<td style="width: 150px">Accepted Reason:</td>' +
            '<td>' +
            d.leave_reason +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="width: 150px">Decline Reason:</td>' +
            '<td>' +
            // not empty
            (d.decline_reason ? d.decline_reason : 'N/A') +
            '</td>' +
            '</tr>' +
            '<tr>' +
            '<td style="width: 150px">Notes:</td>' +
            '<td>' +
            d.notes +
            '</td>' +
            '</tr>' +
            '</table>'
        );
    }

    if ($('.employee-leave-dt').length > 0) {
        var employeeLeaveDt = $('.employee-leave-dt').DataTable({
            stateSave: false,
            bDestroy: true,
            data: window.employeeLeavesDataTable.employee_leaves,
            pageLength: 25,
            order: [],
            language: {
                search: "",
                searchPlaceholder: "Search...",
                lengthMenu: "Show _MENU_",
                zeroRecords: "No leave requests found",
                info: "Showing _START_ to _END_ of _TOTAL_ leave requests",
                infoEmpty: "No leave requests found",
                infoFiltered: "(filtered from _MAX_ total leave requests)",
            },
            columns: [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '<i class="picons-thin-icon-thin-0151_plus_add_new"></i>',
                },
                {
                    data: 'type',
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'start_date.display',
                    sort: 'start_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'end_date.display',
                    sort: 'end_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: 'status',
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'created_date.display',
                    sort: 'created_date.timestamp'
                    },
                    defaultContent: ""
                },
            ],

            dom:
            "<'row'<'col-sm-12 col-md-6 d-flex align-items-center'l><'col-sm-12 col-md-6 d-flex align-items-center justify-content-end'<'filter-pane d-flex mr-2'>f>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7'p>>",
        });

        // Add event listener for opening and closing details
        $('#leave-list-dt tbody').on('click', 'td.dt-control', function () {
            var tr = $(this).closest('tr');
            var row = employeeLeaveDt.row(tr);


            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                // add icon
                $(this).html('<i class="picons-thin-icon-thin-0151_plus_add_new"></i>');

            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
                // add icon
                $(this).html('<i class="picons-thin-icon-thin-0152_minus_delete_remove"></i>');
               // if shown find next row and add class
                tr.next().addClass('child-row');
            }
        });

        document.addEventListener("turbolinks:before-cache", function () {
            if (employeeLeaveDt !== null) {
            employeeLeaveDt.destroy();
            employeeLeaveDt = null;
            }
        });
    }

    var dtdocs = $('.dt-documents').DataTable({
        stateSave: true,
        bLengthChange: true,
        bPaginate: true,
        bFilter: true,
        bDestroy: true,
        columnDefs: [
            { orderable: false, targets: -1 }
        ],
        stateSaveParams: function (settings, data) {
            data.length = 25;
        },
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
        language: {
            emptyTable: "No files uploaded to folder"
        }
    });

    $("div.dt-heading.hs-documents").html('<h5>My Documents Requiring Review</h5>');
    $("div.dt-heading.staff-documents").html('<h5>My Wellbeing Files</h5>');
    document.addEventListener("turbolinks:before-cache", function () {
        if (dtdocs !== null) {
            dtdocs.destroy();
            dtdocs = null;
        }
    });

    var dt2 = $('.dt-simple').DataTable({
        stateSave: true,
        bPaginate: false,
        bLengthChange: false,
        bFilter: true,
        bInfo: true,
        bDestroy: true,
        bAutoWidth: false
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt2 !== null) {
            dt2.destroy();
            dt2 = null;
        }
    });

    var dtSuperSimple = {};

    $('.dt-super-simple').each(function() {
        var $element = $(this);
        var elementId = $element.attr('id');

        dtSuperSimple[elementId] = $element.DataTable({
            stateSave: true,
            bPaginate: true,
            bLengthChange: false,
            bFilter: false,
            bInfo: false,
            bDestroy: true,
            bAutoWidth: false,
            order: [[$element.data('sortordercol') || 0, $element.data('sortorder') || 'asc']]
        });
    });

    document.addEventListener("turbolinks:before-cache", function() {
        Object.keys(dtSuperSimple).forEach(function(key) {
            if (dtSuperSimple[key] !== null) {
                dtSuperSimple[key].destroy();
                dtSuperSimple[key] = null;
            }
        });
        dtSuperSimple = {};
    });

    var dtSuperSimpleNoPaginate = {};

    $('.dt-super-simple-no-paginate').each(function() {
        var $element = $(this);
        var elementId = $element.attr('id');

        dtSuperSimpleNoPaginate[elementId] = $element.DataTable({
            stateSave: true,
            bPaginate: false,
            bLengthChange: false,
            bFilter: false,
            bInfo: false,
            bDestroy: true,
            bAutoWidth: false,
            order: [[$element.data('sortordercol') || 0, $element.data('sortorder') || 'asc']]
        });
    });

    document.addEventListener("turbolinks:before-cache", function() {
        Object.keys(dtSuperSimpleNoPaginate).forEach(function(key) {
            if (dtSuperSimpleNoPaginate[key] !== null) {
                dtSuperSimpleNoPaginate[key].destroy();
                dtSuperSimpleNoPaginate[key] = null;
            }
        });
        dtSuperSimpleNoPaginate = {};
    });


    if ($('.checklist-dt-sorted').length && !$.fn.DataTable.isDataTable('.checklist-dt-sorted')) {
        var checklistDtSorted = $('.checklist-dt-sorted').DataTable({
            order: [[$('.checklist-dt-sorted').data('sortordercol'), 'asc']],
            stateSave: true,
            dom: 'Bfrtip',
            buttons: [
            {
                extend: 'csv',
                text: 'Export CSV',
                className: 'btn btn-primary',
                exportOptions: {
                    columns: ':not(.hide-in-csv), .csv-only',
                    format: {
                        body: function (data, row, column, node) {
                            if (data !== '') {
                                return $(node).text().trim().replace(/\s+/g, ' ');
                            } else {
                                return '';
                            }
                        }
                    }
                }
            }
            ],
            initComplete: function() {
                $(this).addClass('initialized');
            },
            columnDefs: [
                {
                    targets: '.csv-only',
                    visible: false
                }
            ]
        });
        document.addEventListener("turbolinks:before-cache", function () {
            if (checklistDtSorted !== null) {
                checklistDtSorted.destroy();
                checklistDtSorted = null;
            }
        });
    }


    var sortdir = $('.dt-sorted').data('sortorderdir');
    if (sortdir == undefined) { sortdir = 'asc'; }

    if ($.fn.DataTable.isDataTable('.dt-sorted')) {
        $('.dt-sorted').DataTable().destroy();
    }

    var dt4 = $('.dt-sorted').DataTable({
        order: [[$('.dt-sorted').data('sortordercol'), sortdir]],
        stateSave: true
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt4 !== null) {
            dt4.destroy();
            dt4 = null;
        }
    });

    var dt3 = $('.dt-sorted-with-export').DataTable({
        order: [[$('.dt-sorted-with-export').data('sortordercol'), sortdir]],
        stateSave: true,
        dom: 'Bfrtip',
        buttons: [
            {
                extend: 'csv',
                text: 'Export CSV',
                className: 'btn btn-primary'
            }
        ]
    });
    document.addEventListener("turbolinks:before-cache", function () {
        if (dt3 !== null) {
            dt3.destroy();
            dt3 = null;
        }
    });

    if ($('#master-dashboard-transfers').length) {
        var transferTable = $('#master-dashboard-transfers').DataTable();
        var buttonsContainer = $('#dataTableButtons');
        var transferButtons = new $.fn.dataTable.Buttons(transferTable, {
            buttons: [
                {
                    extend: 'csvHtml5',
                    className: 'btn-primary',
                    text: 'Transfers',
                    titleAttr: 'Export',
                    exportOptions: {
                        columns: transferTable.columns().indexes().toArray()
                    }
                }
            ]
        });
        if (buttonsContainer.length) {
            buttonsContainer.empty();
            transferButtons.container().appendTo(buttonsContainer);
        } else {
            transferButtons.container();
        }
        $('#master-dashboard-transfers').closest('.dataTables_wrapper').find('.dt-buttons').remove();
    }

    if ($('.acceptedLeaveTable').length) {
        var leaveTable = $('.acceptedLeaveTable').DataTable({
            bDestroy: true,
            data: window.teamLeavesDataTable.acceptedEmployeeLeaves,
            columns: [
                {
                    data: 'name',
                    defaultContent: ""
                },
                {
                    data: 'type',
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'start_date.display',
                    sort: 'start_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: {
                    _:    'end_date.display',
                    sort: 'end_date.timestamp'
                    },
                    defaultContent: ""
                },
                {
                    data: 'days_count',
                    defaultContent: ""
                },
            ],
            language: {
                emptyTable: "No leave requests found",
                info: "Showing _START_ to _END_ of _TOTAL_ leave requests",
                infoEmpty: "Showing 0 to 0 of 0 leave requests",
                infoFiltered: "(filtered from _MAX_ total leave requests)",
                lengthMenu: "Show _MENU_ leave requests",
                search: "Search:",
                zeroRecords: "No matching leave requests found"
            }
        });

        document.addEventListener("turbolinks:before-cache", function () {
          if (leaveTable !== null) {
            leaveTable.destroy();
            leaveTable = null;
          }
        });
    }

    // Load only if the element exists
    if ($('.holidayAllowanceTable').length) {
        var staffAllowanceTable = $('.holidayAllowanceTable').DataTable({
            bDestroy: true,
            data: window.teamLeavesDataTable.holidayAllowance,
            columnDefs: [{
                defaultContent: "",
                targets: "_all"
            }],
            language: {
                emptyTable: "No staff members found",
                info: "Showing _START_ to _END_ of _TOTAL_ staff members",
                infoEmpty: "Showing 0 to 0 of 0 staff members",
                infoFiltered: "(filtered from _MAX_ total staff members)",
                lengthMenu: "Show _MENU_ staff",
                search: "Search:",
                zeroRecords: "No matching staff members found"
            }
        });
        var staffAllowanceButtons = new $.fn.dataTable.Buttons(staffAllowanceTable, {
            buttons: [
                {
                    extend: 'pdf',
                    text: 'Download PDF',
                    className: 'dropdown-item'
                },
                {
                    extend: 'csv',
                    text: 'Download CSV',
                    className: 'dropdown-item'
                }
        ]
        }).container().appendTo($('#staffAllowanceExport'));

        document.addEventListener("turbolinks:before-cache", function () {
            if (staffAllowanceTable !== null) {
                staffAllowanceTable.destroy();
                staffAllowanceTable = null;
            }
        });
    }

    // Enforce: leave end date cannot be before leave start date.
    // Some pages use ids like "hr/employee_leave_start_time", so we also match by suffix and by CSS classes.
    var leaveStartSelector = '#employee_leave_start_time, input[id$="employee_leave_start_time"], .start-date, .start_date';
    var leaveEndSelector = '#employee_leave_end_time, input[id$="employee_leave_end_time"], .end-date, .end_date';

    $(document).off('apply.daterangepicker.leaveConstraints', leaveStartSelector);
    $(document).off('apply.daterangepicker.leaveConstraints', leaveEndSelector);

    $(document).on('apply.daterangepicker.leaveConstraints', leaveStartSelector, function (ev, picker) {
        var $start = $(this);
        var $form = $start.closest('form');
        var $end = $form.length ? $form.find(leaveEndSelector).first() : $(leaveEndSelector).first();
        if (!$end.length) return;

        var endPicker = $end.data('daterangepicker');
        if (!endPicker || !endPicker.startDate) return;

        var startDate = picker.startDate;
        var endDate = endPicker.startDate;

        // Disallow selecting an end date before the start date
        endPicker.minDate = startDate.clone();

        // If current end is invalid, snap it forward
        if (endDate.isBefore(startDate, 'day')) {
            $end.val(startDate.format('DD/MM/YYYY'));
            endPicker.setStartDate(startDate);
            endPicker.setEndDate(startDate);
        }
    });

    $(document).on('apply.daterangepicker.leaveConstraints', leaveEndSelector, function (ev, picker) {
        var $end = $(this);
        var $form = $end.closest('form');
        var $start = $form.length ? $form.find(leaveStartSelector).first() : $(leaveStartSelector).first();
        if (!$start.length) return;

        var startPicker = $start.data('daterangepicker');
        if (!startPicker || !startPicker.startDate) return;

        var endDate = picker.startDate;

        // Disallow selecting a start date after the end date
        startPicker.maxDate = endDate.clone();

        // If current start is invalid, snap it back
        var startDate = startPicker.startDate;
        if (startDate.isAfter(endDate, 'day')) {
            $start.val(endDate.format('DD/MM/YYYY'));
            startPicker.setStartDate(endDate);
            startPicker.setEndDate(endDate);
        }
    });

    if ($(".genericHrDataTable").length) {
        var order = $(".genericHrDataTable").data("order") || [0, "asc"];
        var genericHrDataTable = $(".genericHrDataTable").DataTable({
            order: [order],
        });

        document.addEventListener("turbolinks:before-cache", function () {
            if (genericHrDataTable !== null) {
                genericHrDataTable.destroy();
                genericHrDataTable = null;
            }
        });
    }

    if ($(".HrSelect2").length) {
        $(".HrSelect2").each(function () {
            $(this).select2({
                placeholder: $(this).data("placeholder"),
                closeOnSelect: $(this).data("closeonselect") !== false,
                width: '100%'
            });
        });
    }

    if ($(".HrSingleDatePicker").length) {
        $(".HrSingleDatePicker").each(function () {
            $(this).daterangepicker({
                autoApply: true,
                showDropdowns: true,
                minYear: new Date().getFullYear() - 100,
                maxYear: new Date().getFullYear() + 5,
                singleDatePicker: true,
                autoUpdateInput: true,
                locale: {
                    cancelLabel: "Clear",
                    format: "DD/MM/YYYY",
                    firstDay: 1
                }
            });
        });
    }
});




$(document).on('turbolinks:load', function () {
    $('#scheduled_report_every').on('change', function () {
        if ($(this).val() == 'week') {
            $('.days-of-week-options').show();
        } else {
            $('.days-of-week-options').hide();
        }
        $('.every-label').text($(this).val() + 's')
    });

    $(document).find('input[data-behaviour~=repeatchbx]').unbind('click');
    $(document).find('input[data-behaviour~=repeatchbx]').on('click', function () {
        if ($('input[data-behaviour~=repeatchbx]').is(':checked')) {
            $('.repeat-options').show();
            $('.scheduled_at_date_row label').text('Starting On');
        } else {
            $('.repeat-options').hide();
            $('.scheduled_at_date_row label').text('Scheduled On');
        }
    });
});

$(document).on('turbolinks:load', function () {
    $('.todo-sidebar-section-sub-section-toggler').not('.disabled').on("click", function () {

        const link = $(this);
        const path = $(this).data('path');
        const sectionId = $(this).data('sectionid');
        var documentsContainer = $('#active-documents-' + sectionId);

        if (path && sectionId && documentsContainer && documentsContainer.children("li").length == 0) {
            link.closest('.todo-sidebar-section-sub-section').find('.todo-sidebar-section-sub-section-content').slideToggle(100);
            $.ajax({
                url: path,
                dataType: 'html',
                success: function(response) {
                    documentsContainer.html(response);
                },
                error: function(xhr, status, error) {
                    documentsContainer.html("Error loading documents");
                }
            });
        } else {
            // Sidebar Sub Sections foldable trigger
            $(this).closest('.todo-sidebar-section-sub-section').find('.todo-sidebar-section-sub-section-content').slideToggle(100);
        }

        $(this).find('i').toggleClass('os-icon-ui-22 os-icon-ui-23');
    });

    // open/highlight relevant bits of the side bar
    const current_section_id = window.hs_section_id;
    if (current_section_id) {
        let section_container = $('.todo-sidebar-section-sub-section[data-sectionid=' + current_section_id + ']');
        section_container.addClass('active');
        let toggler = section_container.find('.todo-sidebar-section-sub-section-toggler');
        section_container.find('.todo-sidebar-section-sub-section-toggler i').toggleClass('os-icon-ui-22 os-icon-ui-23');
        section_container.find('.section-icon i').toggleClass('picons-thin-icon-thin-0111_folder_files_documents picons-thin-icon-thin-0110_folder');
        section_container.find('.todo-sidebar-section-sub-section-content').show();

        var path = toggler.data('path');
        var documentsContainer = $('#active-documents-' + current_section_id);

        if (path && documentsContainer) {
            $.ajax({
                url: path,
                dataType: 'html',
                success: function(response) {
                  documentsContainer.html(response);
                },
                error: function(xhr, status, error) {
                    documentsContainer.html("Error loading documents");
                }
            });
        }
        let current_document_id = window.hs_document_id;
        if (current_document_id) {
            section_container.find('.document-item[data-documentid=' + current_document_id + ']').addClass('active');
        }
    }
});

// Daterange pickers
$(document).on('turbolinks:load', function () {
    $('input.start-date').daterangepicker({
        showDropdowns: true,
        minYear: 2000,
        maxDate: moment(),
        maxYear: moment().year(),
        singleDatePicker: true,
        autoUpdateInput: true,
        autoApply: true,
        locale: {
            cancelLabel: 'Clear',
            format: 'DD/MM/YYYY',
        },
        startDate: $('input.start-date').val() ? $('input.start-date').val() : moment().subtract(1, 'day')
    });
    $('input.end-date').daterangepicker({
        showDropdowns: true,
        minYear: 2000,
        maxDate: moment(),
        maxYear: moment().year(),
        singleDatePicker: true,
        autoUpdateInput: true,
        autoApply: true,
        locale: {
            cancelLabel: 'Clear',
            format: 'DD/MM/YYYY',
        },
        startDate: $('input.end-date').val() ? $('input.end-date').val() : moment()
    });
});


$(document).on('turbolinks:load', function () {
    if ($('.editor-section').length > 0) {
        $.get(window.location.href + '.js', {});
    }
});

function setIntervalWithTurbolinks(intervalFunction, milliseconds) {
    var interval = setInterval(intervalFunction, milliseconds);

    $(document).on('turbolinks:before-cache turbolinks:before-render', function () {
        clearTimeout(interval);
    });
}
window.setIntervalWithTurbolinks = setIntervalWithTurbolinks;


$(document).on('turbolinks:load', function () {
    if ($('#diffhtml').length > 0) {

        let oldHtml = document.getElementById('oldhtml');
        let newHtml = document.getElementById('newhtml');
        let diffHtml = document.getElementById('diffhtml');

        let output = htmldiff(oldHtml.innerHTML, newHtml.innerHTML);
        diffHtml.innerHTML = output;
    }
});

$(document).on('turbolinks:load', function () {
    $(".comment-show").on("click", function () {
        console.log('click');
        const target_id = $(this).data('targetcommentid');
        console.log(target_id);
        $('.comment-popup').removeClass('popup-box-on');
        $(target_id).addClass('popup-box-on');
    });
    $(".comment-hide").on("click", function () {
        $('.comment-popup').removeClass('popup-box-on');
    });

    $(".slide-panel-btn").on("click", function (e) {
        const target_panel = $($(this).data('target'));
        if (target_panel.hasClass('slide-panel-on')) {
            $('.slide-panel').removeClass('slide-panel-on');
            $('.slide-panel-btn').removeClass('active');
            $('.dropdown-menu').dropdown('hide');
        } else {
            $('.slide-panel').removeClass('slide-panel-on');
            $('.slide-panel-btn').removeClass('active');
            target_panel.addClass('slide-panel-on');
            $(this).addClass('active');
            $('.dropdown-menu').dropdown('hide');
        }
        e.stopPropagation()
    });
    $(".slide-panel-btn-close").on("click", function (e) {
        $('.slide-panel').removeClass('slide-panel-on');
        $('.slide-panel-btn').removeClass('active');
        $('.dropdown-menu').dropdown('hide');
        e.stopPropagation()
    });

    $("[data-trigger]").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var taskpanel_id = $(this).attr('data-trigger');
        $(taskpanel_id).toggleClass("show");
    });
    $(".btn-close").on("click", function (e) {
        $('.task-panel').removeClass("show");
    });

})

class addFields {
    // This executes when the function is instantiated.
    constructor() {
        this.links = document.querySelectorAll('.add_fields')
        this.iterateLinks()
    }

    iterateLinks() {
        // If there are no links on the page, stop the function from executing.
        if (this.links.length === 0) return
        // Loop over each link on the page. A page could have multiple nested forms.
        this.links.forEach(link => {
            link.addEventListener('click', e => {
                this.handleClick(link, e)
            })
        })
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Save a unique timestamp to ensure the key of the associated array is unique.
        let time = new Date().getTime()
        // Save the data id attribute into a variable. This corresponds to `new_object.object_id`.
        let linkId = link.dataset.id
        // Create a new regular expression needed to find any instance of the `new_object.object_id` used in the fields data attribute if there's a value in `linkId`.
        let regexp = linkId ? new RegExp(linkId, 'g') : null
        // Replace all instances of the `new_object.object_id` with `time`, and save markup into a variable if there's a value in `regexp`.
        let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null
        // Add the new markup to the form if there are fields to add.
        newFields ? link.insertAdjacentHTML('beforebegin', newFields) : null
    }
}

// Wait for turbolinks to load, otherwise `document.querySelectorAll()` won't work
window.addEventListener('turbolinks:load', () => new addFields())



window.intervalShowHide = function () {
    var radioValue = $("input[name='inspection[interval_type]']:checked").val();
    $('.interval_type_specific').hide();
    if (radioValue == 'time') {
        $('.interval_type_specific.time').show();
    }
    if (radioValue == 'hours') {
        $('.interval_type_specific.hours').show();
    }
    if (radioValue == 'mileage') {
        $('.interval_type_specific.mileage').show();
    }
}

$(document).on('change', '.interval_type_row input[type=radio]', function (event) {
    window.intervalShowHide();
});

$(document).on('turbolinks:load', function () {
    window.intervalShowHide();
});

$(document).on('click', '.change-category', function (event) {
    $('.category-change-section').show();
    event.preventDefault();
});

$(document).on('click', '.change-department', function (event) {
    $('.department-change-section').show();
    event.preventDefault();
});


Dropzone.autoDiscover = false;
Dropzone.Dropzone.autoDiscover = false;
$(document).on('turbolinks:load', function () {
    if ($(".misdropzone").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        new Dropzone.Dropzone(".misdropzone", {
            dictDefaultMessage: 'Drop files here or click to upload',
            maxFilesize: 10
        });
    }


    if ($(".filingcabmisdropzone").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        var dz = new Dropzone.Dropzone(".filingcabmisdropzone", {
            dictDefaultMessage: 'Drop files here or click to upload',
            maxFilesize: 10
        });
        dz.on("success", function (file) {
            $.get(window.location.pathname + '.js');
        });
    }

    if ($(".reloadmisdropzone").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        var dz = new Dropzone.Dropzone(".reloadmisdropzone", {
            dictDefaultMessage: 'Drop documents here or click to upload',
            maxFilesize: 10
        });
        dz.on("success", function (file) {
            $.get(window.location.pathname + '.js');
        });
    }

    if ($(".reloadmisdropzoneimageonly").length > 0) {
        // Dropzone.options.misdropzone = {
        // };
        var dzimage = new Dropzone.Dropzone(".reloadmisdropzoneimageonly", {
            dictDefaultMessage: 'Select photos',
            maxFilesize: 10,
            acceptedFiles: ".jpeg,.jpg,.png,.gif",
            capture: "camera"
        });
        dzimage.on("success", function (file) {
            $.get(window.location.pathname + '.js');
        });
    }
});



$.fn.textWidth = function (text, font) {
    if (!$.fn.textWidth.fakeEl) $.fn.textWidth.fakeEl = $('<span>').hide().appendTo(document.body);
    $.fn.textWidth.fakeEl.text(text || this.val() || this.text()).css('font', font || this.css('font'));
    return $.fn.textWidth.fakeEl.width();
};

function inline_text_box_width_adjust(element) {
    var padding = 60; // Works as a minimum width
    var valWidth = ($(element).textWidth() + padding) + 'px';
    $('#' + element.id + '-width').html(valWidth);
    $('.document-title-field ').css('width', valWidth);
}

// Expandable text input
$(document).on('turbolinks:load', function () {
    $('.document-title-field ').on('input', function () {
        inline_text_box_width_adjust(this);
    }).trigger('input');
    inline_text_box_width_adjust('.document-title-field');
});


$(document).on('turbolinks:load', function () {
    if (window.calendarEventsUrl) {
        var calendarEl = document.getElementById('calendar');
        let calendar = new Calendar(calendarEl, {
            plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
            editable: true,
            initialView: 'dayGridMonth',
            locale: 'en-gb',
            titleFormat: {
                month: '2-digit',
                year: 'numeric',
                day: 'numeric',
            },
            headerToolbar: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth listWeek'
            },
            buttonText: {
                today: 'Today',
                month: 'Month View',
                list: 'List View'
            },
            eventSources: [
                {
                    url: window.calendarEventsUrl,
                    color: 'yellow',
                    textColor: 'black'
                }
            ],
            eventTimeFormat: {
                hour: 'numeric',
                minute: 'numeric',
                meridiem: 'short',
                omitZeroMinute: true
            },
            eventDidMount: function(info) {
                $(info.el).tooltip({
                    title: info.event.title,
                });
              },
            dateClick: function (info) {
                $.get(window.newEventsUrl + '?scheduled_at=' + info.dateStr);
            },
            eventClick: function (info) {
                info.jsEvent.preventDefault();
                $.get(info.event.url + '.js');
            },
            eventDrop: function (info) {
                $.ajax({
                    url: info.event.url + '.js',
                    type: 'PUT',
                    data: {
                        scheduled_report: {
                            scheduled_at: info.event.start
                        }
                    },
                });
                // $.put(info.event.url + '?scheduled_at_date=' + info.dateStr);
            },
            noEventsContent: 'No checklists scheduled',
        });
        calendar.render();
        window.calendar = calendar;
    }
});

$(document).on('turbolinks:load', function () {
  $('.copy-button').on('click', function(e) {
    e.preventDefault();
    var copyInput = document.getElementById('copy-input').value;
    navigator.clipboard.writeText(copyInput);
    $(this).tooltip({
        title: 'Copied to clipboard!',
        placement: 'bottom',
        trigger: 'manual'
    }).tooltip('show');
    setTimeout(function() {
        $(this).tooltip('hide');
    }
    .bind(this), 1500);
  });
});

$(".single-daterange").daterangepicker({
    parentEl: "#newLeaveEventModal .modal-body"
});

$(document).on('turbolinks:load', function () {
    $('.form-datepicker').daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        locale: {
            format: 'DD/MM/YYYY',
            firstDay: 1,
        },
    })

    $('.form-datepicker').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    $('[data-datepicker]').each(function() {
        var options = {
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            showDropdowns: true,
            locale: {
                format: 'DD/MM/YYYY',
                firstDay: 1,
            },
        };

        var additionalOptions = $(this).data("datepicker");
        jQuery.extend(options, additionalOptions);
        $(this).daterangepicker(options);
    });

    $('[data-datepicker]').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    $('.app-datepicker').each(function() {
        const $el = $(this);
        // Fields with custom time-based behavior are initialized separately below
        if ($el.hasClass('past-only')) return;
        if ($el.hasClass('future-only')) return;
        if ($el.hasClass('single-daterange-with-time')) return;
        if ($el.data('daterangepicker')) return;

        const isLeaveStartEnd = $el.hasClass('start-date') || $el.hasClass('end-date');
        const leaveMinDate = moment().subtract(5, 'years');
        const leaveMaxDate = moment().add(5, 'years');

        $el.daterangepicker({
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            // Leave start/end and explicit year-dropdown fields
            showDropdowns: $el.hasClass('start-date') || $el.hasClass('end-date') || $el.hasClass('app-datepicker-with-year'),
            // Keep leave dates within a reasonable window
            minDate: isLeaveStartEnd ? leaveMinDate : undefined,
            maxDate: isLeaveStartEnd ? leaveMaxDate : undefined,
            locale: {
                format: 'DD/MM/YYYY',
                firstDay: 1,
            },
        });
    })

    $('.app-datepicker:not(.past-only):not(.future-only):not(.single-daterange-with-time)').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    const defaultDob = moment('01/01/1990', 'DD/MM/YYYY');

    $('.date-of-birth').daterangepicker({
        autoApply: true,
        autoUpdateInput: false,
        singleDatePicker: true,
        showDropdowns: true,
        maxDate: moment(),
        minDate: moment('01/01/1940', 'DD/MM/YYYY'),
        startDate: defaultDob,
        locale: {
            format: 'DD/MM/YYYY',
            firstDay: 1,
        },
    });

    $('.date-of-birth').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

    
    $('.past-only').each(function() {
        const $el = $(this);
        if ($el.data('daterangepicker')) return;

        const withTime = $el.hasClass('single-daterange-with-time')
            || /[HhmsaA]/.test($el.attr('date_format') || '');
        const format = $el.attr('date_format') || (withTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY');

        $el.daterangepicker({
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            timePicker: withTime,
            timePicker24Hour: withTime,
            showDropdowns: true,
            minDate: moment('01/01/2020', 'DD/MM/YYYY'),
            maxDate: moment(),
            locale: {
                format: format,
                firstDay: 1,
            },
        });
    });

    $('.past-only').on('apply.daterangepicker', function(ev, picker) {
        const $el = $(this);
        const withTime = $el.hasClass('single-daterange-with-time')
            || /[HhmsaA]/.test($el.attr('date_format') || '');
        const format = $el.attr('date_format') || (withTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY');
        $el.val(picker.startDate.format(format));
    });

    $('.future-only').each(function() {
        const $el = $(this);
        if ($el.data('daterangepicker')) return;

        $el.daterangepicker({
            autoApply: true,
            autoUpdateInput: false,
            singleDatePicker: true,
            showDropdowns: true,
            minDate: moment().startOf('day'),
            locale: {
                format: 'DD/MM/YYYY',
                firstDay: 1,
            },
        });
    });

    $('.future-only').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });

});

$(document).on('turbolinks:load', function () {
    if ($("#return_to_work_absence_start, #return_to_work_return_date, #absence_length").length === 3) {
        let absenceStart = $('#return_to_work_absence_start')[0].value
        let absenceEnd = $('#return_to_work_return_date')[0].value

        function calcAbsenceLength() {
            if (absenceStart && absenceEnd) {
                const momentStart = moment(absenceStart, 'DD/MM/YYYY')
                const momentEnd = moment(absenceEnd, 'DD/MM/YYYY')
                $("#absence_length")[0].innerHTML = moment.preciseDiff(momentStart, momentEnd)
            }
        }

        calcAbsenceLength();

        $('#return_to_work_absence_start').on('apply.daterangepicker', function(ev, picker) {
            absenceStart = picker.startDate.format('DD/MM/YYYY');
            calcAbsenceLength();
        });

        $('#return_to_work_return_date').on('apply.daterangepicker', function(ev, picker) {
            absenceEnd = picker.startDate.format('DD/MM/YYYY');
            calcAbsenceLength();
        });
    }
});

// Code for showing/hiding custom meeting title text field for appraisals
$(document).on('turbolinks:load', function () {
    if ($("#custom-meeting-title-form-group")) {
        changeCustomMeetingTitle();
    }

    $('#meeting-title-select').on('change', function () {
        changeCustomMeetingTitle();
    });

    function changeCustomMeetingTitle() {
        let meetingTitleSelect = $('#meeting-title-select');
        let customMeetingTitle = $('#custom-meeting-title');
        let customMeetingTitleFormGroup = $('#custom-meeting-title-form-group');

        if (meetingTitleSelect.val() === "other") {
            customMeetingTitleFormGroup.show();
        } else {
            customMeetingTitleFormGroup.hide();
            customMeetingTitle.val("")
        }
    }
});

$(document).on('turbolinks:load', function () {
    $('#uk-employment-documentation-button').on('click', function () {
        $('#hr-document-select').val('uk_employment_documentation')
    });

    $("#new-custom-field-btn").on("click", function() {
        const activeTab = $(".nav-tabs .active").data("report");
        const link = $(this).attr("href");
        $(this).attr("href", link + "?previous_tab=" + activeTab);
    });
});

// Code for showing/hiding custom document label text field for a hr document
$(document).on('turbolinks:load', function () {
    if ($("#other-document-label-form-group")) {
        changeOtherDocumentLabel();
    }

    $('#hr_document-select').on('change', function () {
        changeOtherDocumentLabel();
    });

    function changeOtherDocumentLabel() {
        let hrDocumentSelect = $('#hr_document-select');
        let otherDocumentLabel = $('#other-document-label');
        let otherDocumentLabelFormGroup = $('#other-document-label-form-group');

        if (hrDocumentSelect.val() === "other") {
            otherDocumentLabelFormGroup.show();
        } else {
            otherDocumentLabelFormGroup.hide();
            otherDocumentLabel.val("")
        }
    }
});


// Display fuel containers tab on total-fuel-stat-box click for the fuel page
$(document).on('turbolinks:load', function () {
    $('#total-fuel-box').on('click', function (e) {
        e.preventDefault();
        $('#fuel-index-tabs #fuel-containers-tab').tab('show');
    });
});

// Hide fuel source fields depending on the fuel source type
$(document).on('turbolinks:load', function () {
    if ($('.source-type-checkbox').length > 0) {
        showHideFuelSourceFields();
    }

    $('.source-type-checkbox').on('change', function () {
        showHideFuelSourceFields();
    });

    function showHideFuelSourceFields() {
        const source_type = $('.source-type-checkbox:checked').val();

        if ($('.source-type-checkbox').length <= 0) {
            return;
        }

        const internalFuelSourceDiv = $('#internal-fuel-source-div');
        const externalFuelSourceDiv = $('#external-fuel-source-div');
        const amountFuelRemainingDiv = $('#amount-fuel-remaining-div');
        const amountFuelRemainingField = $('#fuel_transfer_amount_remaining');

        if (source_type == 'external') {
            internalFuelSourceDiv.hide();
            externalFuelSourceDiv.show();
            amountFuelRemainingDiv.hide();
            amountFuelRemainingField.val('');
        } else {
            internalFuelSourceDiv.show();
            externalFuelSourceDiv.hide();
            amountFuelRemainingDiv.show();
        }
    }
});
// Hides form for release batch based on selected option
$(document).on('turbolinks:load', function () {
    if ($('#release-batch-select').length > 0) {
        changeReleaseBatchFields();
    }

    $('#release-batch-select').on('change', function () {
        changeReleaseBatchFields();
    });

    function changeReleaseBatchFields() {
        if ($('#release-batch-select').val() == '') {
            $('#fields-for-release-batch').show();
        } else {
            $('#fields-for-release-batch').hide();
            $('#release-batch-name-field').val('');
        }
    }
});

let selectedDocs = new Set();

$(document).on('turbolinks:load', function () {
  const $modal = $('#shareFilesModal');
  const tableSelector = '.dt-simple';
  const table = $modal.find(tableSelector).DataTable();

  $modal.on('change', '.hs-doc-checkbox', function () {
    const docId = parseInt($(this).val());
    if ($(this).is(':checked')) {
      selectedDocs.add(docId);
    } else {
      selectedDocs.delete(docId);
    }
  });

  table.on('draw', function () {
    $modal.find('.hs-doc-checkbox').each(function () {
      const docId = parseInt($(this).val());
      $(this).prop('checked', selectedDocs.has(docId));
    });
  });

  $modal.find('form').on('submit', function () {
    $(this).find('input[name="hs_document_ids[]"]').remove();

    selectedDocs.forEach(docId => {
      $(this).append(
        $('<input>').attr({
          type: 'hidden',
          name: 'hs_document_ids[]',
          value: docId
        })
      );
    });
  });

  $modal.on('hidden.bs.modal', function () {
    selectedDocs.clear();
  });
});
